@for(catGroup of categories(); track catGroup; let last =$last; let i = $index) {
<div class="points-categories" [class.mb-3]="categories().length > 0 && !last">
    @for(cat of catGroup; track cat; let j = $index) {
    <div class="points-categories__element" (click)="currentActiveCategoryIndex.set([i,j]); cat.onClick()"
        [class.disabled]="cat.disabled"
        [class.active]="currentActiveCategoryIndex()[0] === i && currentActiveCategoryIndex()[1] === j">
        <span class=" points-categories__element__label">
            {{cat.label}}
        </span>
        <div>
            <span class="points-categories__element__count">{{cat.count > 0 ? cat.count : ''}}</span>
            <span>
                <i
                    [ngClass]="currentActiveCategoryIndex()[0] === i && currentActiveCategoryIndex()[1] === j ? 'bi bi-arrow-up-right-circle-fill' : 'bi bi-arrow-up-right-circle'"></i>
            </span>

        </div>
    </div>
    }
</div>
}